export default "__VITE_ASSET__Bq4ZWsZi__"